__turbopack_context__.v({
  "container": "CloudinaryImage-module__J6WUSa__container",
  "fadeInItems": "CloudinaryImage-module__J6WUSa__fadeInItems",
  "loaded": "CloudinaryImage-module__J6WUSa__loaded",
  "spacing--lg": "CloudinaryImage-module__J6WUSa__spacing--lg",
  "spacing--md": "CloudinaryImage-module__J6WUSa__spacing--md",
  "spacing--sm": "CloudinaryImage-module__J6WUSa__spacing--sm",
  "spacing--xl": "CloudinaryImage-module__J6WUSa__spacing--xl",
  "spacing--xs": "CloudinaryImage-module__J6WUSa__spacing--xs",
  "spacing--xxl": "CloudinaryImage-module__J6WUSa__spacing--xxl",
  "spacing--xxs": "CloudinaryImage-module__J6WUSa__spacing--xxs",
  "spacing--xxxl": "CloudinaryImage-module__J6WUSa__spacing--xxxl",
  "spacing--xxxs": "CloudinaryImage-module__J6WUSa__spacing--xxxs",
});
